/** Retain the existing server-rendered article before React replaces its root. */
export interface BlogArticleSnapshot {
    pathname: string;
    title: string;
    description: string;
    html: string;
    image?: string;
    hreflangs: { lang: string; url: string }[];
}
let snapshot: BlogArticleSnapshot | null = null;
const decoded = (path: string): string => {
    try { return decodeURIComponent(path); } catch { return path; }
};
export function captureBlogArticleSnapshot(): void {
    snapshot = null;
    if (typeof document === 'undefined') return;
    const pathname = window.location.pathname;
    if (!/^\/(?:[a-z]{2}\/)?blog\/[^/]+\/?$/.test(pathname)) return;
    const article = document.querySelector('#root main.blog-ssr-shell');
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!article?.querySelector('h1') || !canonical) return;
    if (decoded(new URL(canonical.href).pathname) !== decoded(pathname)) return;
    snapshot = {
        pathname: decoded(pathname), title: document.title,
        description: document.querySelector<HTMLMetaElement>('meta[name="description"]')?.content || '',
        html: article.outerHTML,
        image: document.querySelector<HTMLMetaElement>('meta[property="og:image"]')?.content,
        hreflangs: Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="alternate"][hreflang]')).map(link => ({ lang: link.hreflang, url: link.href })),
    };
}
export function readBlogArticleSnapshot(pathname: string): BlogArticleSnapshot | null {
    return snapshot?.pathname === decoded(pathname) ? snapshot : null;
}
export function matchesBlogArticleRoute(article: any, slug: string | undefined, language: string): boolean {
    if (!article || !slug || article.lang !== language || typeof article.slug !== 'string') return false;
    const candidate = article.slug.startsWith(`${language}/`) ? article.slug.slice(language.length + 1) : article.slug;
    return decoded(candidate) === decoded(slug);
}
